var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOurValues2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79.851,
    height: 72.999,
    viewBox: "0 0 79.851 72.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1,.cls-2,.cls-3{fill:#fff}.cls-1{stroke:#345e86;stroke-width:.5px}.cls-3{stroke:#345e87;stroke-width:1.5px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1543",
    transform: "translate(-363.648 -1017.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6789",
    d: "M3.65 123.689H1.964v1.964H0v1.686h1.964v1.961H3.65v-1.964h1.964v-1.686H3.65z",
    className: "cls-1",
    transform: "translate(436.898 900.353)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6790",
    d: "M3.65 123.689H1.964v1.964H0v1.686h1.964v1.961H3.65v-1.964h1.964v-1.686H3.65z",
    className: "cls-1",
    transform: "translate(363.898 913.353)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6792",
    d: "M159.055 173.895v1.686h-1.686v-1.686zm0 3.372v1.686h-1.686v-1.686z",
    className: "cls-2",
    transform: "translate(212.309 889.297)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6793",
    d: "M32.166 53.325h1.686v1.686h-1.686z",
    className: "cls-2",
    transform: "translate(387.156 1035.314)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6794",
    d: "M32.166 53.325h1.686v1.686h-1.686z",
    className: "cls-2",
    transform: "translate(397.156 972.314)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6791",
    d: "M32.166 53.325h1.686v1.686h-1.686z",
    className: "cls-2",
    transform: "translate(365.156 964.314)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "world",
    transform: "translate(371.25 1018.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1518",
    transform: "translate(5.118 5.118)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1517"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6780",
    d: "M67.282 36.652a30.63 30.63 0 1 0 30.63 30.63 30.665 30.665 0 0 0-30.63-30.63zM94.081 58.4H92.2a3.779 3.779 0 0 0-1.681.4l-.691.345a1.363 1.363 0 0 1-1.362-.085l-2.6-1.735a1.2 1.2 0 0 0-.665-.2h-.318l.888-1.333a.239.239 0 0 1 .2-.107h1.869v.521a1.2 1.2 0 0 0 2.38.21l.438.219a3.134 3.134 0 0 0 1.395.329h1.507q.28.712.521 1.436zm-8.965-11.061a.081.081 0 0 1 .023-.057l.9-.9a1.2 1.2 0 0 0 .085-.094q.793.713 1.532 1.483l-.754.754a1.2 1.2 0 1 0 1.7 1.7l.645-.645a28.311 28.311 0 0 1 3.234 5h-.435a.726.726 0 0 1-.322-.076l-1.85-.925a2.652 2.652 0 0 0-1.18-.278h-2.728a2.634 2.634 0 0 0-2.2 1.175l-1.775 2.664h-1.114a.881.881 0 0 1-.88-.88v-2.131a.08.08 0 0 1 .055-.076l2.341-.78a4 4 0 0 0 1.557-.962 3.956 3.956 0 0 0 1.166-2.816zm-36.681-1.056a1.189 1.189 0 0 0 .085.094l1.28 1.28a1.2 1.2 0 0 0 1.7 0l1.809-1.81a1.351 1.351 0 0 1 .961-.4h1.579v.08a1.2 1.2 0 0 0 1.733 1.073l2.094-1.047a1.009 1.009 0 0 1 .449-.106H64.4a2.065 2.065 0 0 0-.006 3.438l1.649 1.1a.08.08 0 0 1 .035.066v.595a.08.08 0 0 1-.08.08h-.551a2.94 2.94 0 0 0-2.092.867l-8.067 8.067a.08.08 0 0 1-.057.023h-2.025a3.763 3.763 0 0 0-3.759 3.759v.584l-1.33-.266a1.034 1.034 0 0 1-.726-.555l-.79-1.579a1.2 1.2 0 0 0-1.073-.663h-.715a1.358 1.358 0 0 1-1.29-.93l-1.67-5.011a28.4 28.4 0 0 1 6.582-8.739zm18.847 49.229A28.232 28.232 0 0 1 40.467 58.45l.781 2.343a3.753 3.753 0 0 0 3.539 2.57l.458.917a3.417 3.417 0 0 0 2.4 1.834l4.575.915a1.319 1.319 0 0 1 .677.362 3.713 3.713 0 0 0 1.286.841l-.836 2.51a1.2 1.2 0 0 0-.062.379v2.559a3.777 3.777 0 0 0 1.5 3.007l3.071 2.3a1.366 1.366 0 0 1 .544 1.087v6.9a3.746 3.746 0 0 0 .631 2.085l1.844 2.767a2.155 2.155 0 0 0 1.8.961h.446a1.521 1.521 0 0 0 1.519-1.519V89.08a1.986 1.986 0 0 1 .586-1.414L67.6 85.3a4.423 4.423 0 0 0 1.063-1.719l.749-2.247a.08.08 0 0 1 .076-.055h.638a2.475 2.475 0 0 0 2.4-1.879l.862-3.446a2.491 2.491 0 0 0-.652-2.354l-1.672-1.672a2.463 2.463 0 0 0-1.753-.726h-1.533l-4.392-4.392a2.463 2.463 0 0 0-1.753-.726h-6.1a1.315 1.315 0 0 1-.936-.388 3.71 3.71 0 0 0-1.9-1.018l-.845-.169v-1.066a1.361 1.361 0 0 1 1.36-1.36h1.36v.08a1.2 1.2 0 1 0 2.4 0v-.785l.023-.021 8.067-8.067a.556.556 0 0 1 .4-.164H66a2.482 2.482 0 0 0 2.479-2.479v-.595a2.474 2.474 0 0 0-1.1-2.063l-1.013-.675 1.943-.486a1.918 1.918 0 0 0-.465-3.779h-7.72a3.419 3.419 0 0 0-1.522.359l-.793.4a2 2 0 0 0-1.564-.756h-1.979a3.734 3.734 0 0 0-2.658 1.1l-.961.961-.359-.358a28.17 28.17 0 0 1 33.986 0l-.832.832a2.463 2.463 0 0 0-.726 1.753v2.156a1.573 1.573 0 0 1-.464 1.119 1.592 1.592 0 0 1-.619.382l-2.341.78a2.476 2.476 0 0 0-1.7 2.352v2.117a3.255 3.255 0 0 0 .454 1.656 4.554 4.554 0 0 0-1.246 1.253l-1.132 1.7a3.746 3.746 0 0 0-.631 2.085v2.289a3.746 3.746 0 0 0 .631 2.085l1.37 2.054a3.751 3.751 0 0 0 3.127 1.674h3.184a1.357 1.357 0 0 1 1.29.93l.286.858a6.787 6.787 0 0 1 .349 2.15v.906a12.871 12.871 0 0 0 .5 3.537l2.057 7.2a28.153 28.153 0 0 1-20.549 8.889zM59.3 77.07l-3.071-2.3a1.366 1.366 0 0 1-.544-1.088v-2.367l.945-2.834h5a.081.081 0 0 1 .057.023l4.744 4.744a1.2 1.2 0 0 0 .848.351h2.029a.081.081 0 0 1 .057.023l1.674 1.678a.081.081 0 0 1 .021.076l-.86 3.441a.08.08 0 0 1-.078.06h-.638a2.476 2.476 0 0 0-2.352 1.7l-.749 2.247a2.009 2.009 0 0 1-.483.781l-2.369 2.365a4.37 4.37 0 0 0-1.288 3.11v.471l-1.211-1.817a1.355 1.355 0 0 1-.228-.754v-6.9a3.775 3.775 0 0 0-1.504-3.01zm28.778 1.691a10.479 10.479 0 0 1-.4-2.878v-.906a9.183 9.183 0 0 0-.472-2.908l-.286-.858a3.754 3.754 0 0 0-3.566-2.57h-3.186a1.357 1.357 0 0 1-1.131-.605l-1.37-2.054a1.355 1.355 0 0 1-.228-.754v-2.29a1.355 1.355 0 0 1 .228-.754l1.132-1.7a2.155 2.155 0 0 1 1.8-.961h4.237l2.3 1.534a3.767 3.767 0 0 0 3.766.234l.691-.345a1.367 1.367 0 0 1 .607-.146h2.563A28.2 28.2 0 0 1 89.7 84.424z",
    className: "cls-3",
    transform: "translate(-36.652 -36.652)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1520",
    transform: "translate(10.232 10.232)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1519"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6781",
    d: "M75.342 73.637l-.013-.014a1.206 1.206 0 0 0-1.706 1.706l.013.013a1.211 1.211 0 0 0 1.679 0l.027-.027a1.211 1.211 0 0 0 0-1.678z",
    className: "cls-3",
    transform: "translate(-73.272 -73.272)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1522",
    transform: "translate(5.118 5.118)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1521"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6782",
    d: "M42.969 36.652a6.325 6.325 0 0 0-6.318 6.318 1.2 1.2 0 1 0 2.4 0 3.923 3.923 0 0 1 3.919-3.919 1.2 1.2 0 0 0 0-2.4z",
    className: "cls-3",
    transform: "translate(-36.651 -36.652)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1524"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1523"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6783",
    d: "M11.436 0A11.449 11.449 0 0 0 0 11.436a1.2 1.2 0 1 0 2.4 0A9.047 9.047 0 0 1 11.436 2.4a1.2 1.2 0 1 0 0-2.4z",
    className: "cls-3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1526",
    transform: "translate(58.859 58.859)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1525"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6784",
    d: "M423.543 421.836l-.014-.013a1.211 1.211 0 0 0-1.678 0l-.027.027a1.21 1.21 0 0 0 0 1.678l.013.014a1.206 1.206 0 1 0 1.706-1.705z",
    className: "cls-3",
    transform: "translate(-421.486 -421.485)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1528",
    transform: "translate(58.864 58.863)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1527"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6785",
    d: "M427.835 421.516a1.2 1.2 0 0 0-1.2 1.2 3.923 3.923 0 0 1-3.919 3.919 1.2 1.2 0 1 0 0 2.4 6.325 6.325 0 0 0 6.318-6.318 1.2 1.2 0 0 0-1.199-1.201z",
    className: "cls-3",
    transform: "translate(-421.517 -421.516)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1530",
    transform: "translate(58.864 58.863)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1529"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6786",
    d: "M432.953 421.516a1.2 1.2 0 0 0-1.2 1.2 9.047 9.047 0 0 1-9.037 9.037 1.2 1.2 0 1 0 0 2.4 11.449 11.449 0 0 0 11.436-11.436 1.2 1.2 0 0 0-1.199-1.201z",
    className: "cls-3",
    transform: "translate(-421.517 -421.516)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1532",
    transform: "translate(25.591 15.354)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1531"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6787",
    d: "M188.087 110.615a1.2 1.2 0 0 0-1.609-.537l-2.559 1.28a1.2 1.2 0 1 0 1.073 2.146l2.559-1.28a1.2 1.2 0 0 0 .536-1.609z",
    className: "cls-3",
    transform: "translate(-183.255 -109.952)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1534",
    transform: "translate(47.344 14.075)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1533"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6788",
    d: "M340.228 100.792a1.2 1.2 0 0 0-1.2 1.2v1.28a1.2 1.2 0 1 0 2.4 0v-1.28a1.2 1.2 0 0 0-1.2-1.2z",
    className: "cls-3",
    transform: "translate(-339.028 -100.792)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurValues2);
export default __webpack_public_path__ + "static/media/Our_Values_2.d4ae834dfec2c061c54060d111f8c721.svg";
export { ForwardRef as ReactComponent };